import firefighters from './lists/firefighters'
import ellipsePayrolls from './lists/ellipse-payrolls'
import products from './lists/products'

export default {
  namespaced: true,

  modules: {
    firefighters,
    ellipsePayrolls,
    products
  }
}
